import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    mensajes: [],
};

const mutations = {
    updateField,

    'INICIALIZAR' (state) {
        state.mensajes = [];
    },
    'SET_MENSAJES' (state, mensajes) {
        state.mensajes = mensajes.sort((a, b) => {
            return new Date(b.fechaRegistro) - new Date(a.fechaRegistro);
        });
    },
    'ADD_MENSAJE' (state, mensaje) {
        // state.mensajes.push(mensaje);
        let itemKey = state.mensajes.findIndex(t => t.id == mensaje.id);

        if (itemKey == -1) {
            state.mensajes = [...state.mensajes, mensaje];

            /* Ordenamos la lista de mensajes */
            state.mensajes = state.mensajes.sort((a, b) => {
                return new Date(b.fechaRegistro) - new Date(a.fechaRegistro);
            });
        }
    },
    'SET_LEIDO' (state, params) {
        let mensaje = state.mensajes.find(t => t.id == params.mensajeId);

        if (mensaje) {
            mensaje.leido = (/true/i).test(params.leido);
        }
    },
    'REMOVE_MENSAJE' (state, mensajeId) {
        let itemKey = state.mensajes.findIndex(t => t.id == mensajeId);

        if (itemKey != -1) {
            state.mensajes.splice(itemKey, 1);

            // /* Ordenamos la lista de mensajes */
            // state.mensajes = state.mensajes.sort((a, b) => {
            //     return new Date(b.fechaRegistro) - new Date(a.fechaRegistro);
            // });
        }
    },        
};

const actions = {
    getMensajes: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit ('INICIALIZAR');

            apiAxios.get('mensajes')
                .then(res => {
                    commit ('SET_MENSAJES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    addMensaje: ( { commit }, mensaje ) => {
        return new Promise((resolve, reject) => {
            commit ('ADD_MENSAJE', mensaje);
            resolve();
        })
    },
    setMensajeLeido: ( { commit }, mensajeId ) => {
        return new Promise((resolve, reject) => {
            apiAxios.post(`mensajes/${mensajeId}/leido`)
            .then(() => {
                commit ('SET_LEIDO', {
                    mensajeId,
                    leido: true
                });
                resolve();
            })
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setMensajeNoLeido: ( { commit }, mensajeId ) => {
        return new Promise((resolve, reject) => {
            apiAxios.post(`mensajes/${mensajeId}/no-leido`)
                .then(() => {
                    commit ('SET_LEIDO', {
                            mensajeId,
                            leido: false
                        });
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    delete: ( { commit }, mensajeId ) => {
        return new Promise((resolve, reject) => {
            apiAxios.post(`mensajes/${mensajeId}/delete`)
                .then(() => {
                    commit('REMOVE_MENSAJE', mensajeId);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },    
};

const getters = {
    getField,
    
    mensajes(state) {
        return state.mensajes;
    },

    mensajesNoLeidos(state) {
        return state.mensajes.filter(t => !t.leido).length;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}